import React from 'react'
import { useStep4Props } from './types'
import Step4View from './views/Step4View'
import useStep4 from './hooks/useStep4'
import { wrap } from '../../../utils/globalUtils'

const Step4: React.FC<useStep4Props> = wrap(Step4View, useStep4)
export default Step4
